import React, { useState, useEffect } from 'react';
import { Box } from "@mui/material";
import DetailsPageLowerLayer from '../DetailsPageLowerLayer/DetailsPageLowerLayer';
import TopSection from '../../CommonComponents/TopSection';
import VisibilityIcon from '@mui/icons-material/Visibility';
import TicketDetailsModal from '../DetailsPageLowerLayer/TicketDetailsModal';
import { fetchTicketSummary } from '../../services/UserRole/SupportTicketService';
import { jwtDecode } from "jwt-decode";
import { useAccessToken } from "../../auth/useAccessToken";

const formatDate = (ts) => {
    if (!ts) return '';
    const d = new Date(ts);
    return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(
        d.getDate()
    ).padStart(2, '0')}`;
};

const TicketSummary = () => {
    const breadcrumbArray = ["User Access Management", "Ticket Summary"];
    const [rows, setRows] = useState([]);
    const [loading, setLoading] = useState(false);
    const [openDetailsModal, setOpenDetailsModal] = useState(false);
    const [selectedTicket, setSelectedTicket] = useState(null);
    const accessToken = useAccessToken();
    const [loggedInEmail, setLoggedInEmail] = useState("");

    const columns = [
        {
            field: 'ticketNumber',
            headerName: 'Ticket Number',
            flex: 1,
            cellRenderer: (params) => {
                const ticketNo = params.data?.ticketNumber;
                const url = params.data?.ticketId;
                if (!url || !ticketNo) return "";

                return (
                    <a
                        href={url}
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{ color: '#1976d2', textDecoration: 'underline' }}
                        onClick={(e) => e.stopPropagation()}
                    >
                        {ticketNo}
                    </a>
                );
            }
        },
        { field: 'menu', headerName: 'Menu', flex: 1 },
        { field: 'subMenu', headerName: 'Sub Menu', flex: 1 },
        { field: 'category', headerName: 'Category', flex: 1 },
        { field: 'priority', headerName: 'Priority', flex: 1 },
        { field: 'status', headerName: 'Status', flex: 1 },
        { field: 'initiatedBy', headerName: 'Initiated By', flex: 1 },
        { field: 'initiatedDateTime', headerName: 'Initiated Date Time', flex: 1 },
        {
            field: 'viewDetails',
            headerName: 'View Details',
            flex: 1,
            cellRenderer: (params) => (
                <Box
                    sx={{ display: 'flex', my: 1, cursor: 'pointer' }}
                    onClick={() => {
                        setSelectedTicket(params.data);
                        setOpenDetailsModal(true);
                    }}
                >
                    <VisibilityIcon />
                </Box>
            )
        }
    ];

    useEffect(() => {
        if (!accessToken) return;
        try {
            const parsed = jwtDecode(accessToken);
            setLoggedInEmail(parsed?.unique_name || "");
        } catch (err) {
            console.error("Failed to decode token:", err);
        }
    }, [accessToken]);

    useEffect(() => {
        if (!loggedInEmail) return;
        const fetchTicketDetails = async () => {
            try {
                setLoading(true);
                const data = await fetchTicketSummary(loggedInEmail);

                // Map API response to table rows
                const mappedRows = data.map((item, index) => ({
                    id: item.id,
                    ticketNumber: item.ticketNumber,
                    ticketId: item.ticketId,
                    menu: item.menu,
                    subMenu: item.subMenu,
                    category: item.category,
                    priority: item.urgency,
                    description: item.issueDescription,
                    status: item.status,
                    initiatedBy: loggedInEmail,
                    initiatedDateTime: item.creationDate,
                    closingDate: item.closingDate
                }));
                setRows(mappedRows);
            } catch (error) {
                console.error("Error fetching tickets", error);
            } finally {
                setLoading(false);
            }
        };
        fetchTicketDetails();
    }, [loggedInEmail]);

    return (
        <div>
            <TopSection breadcrumbArray={breadcrumbArray} hideHeader={true} headerName={""} hideTitle={true} />
            <DetailsPageLowerLayer
                hideTabs
                tabs={[{
                    rows,
                    columns,
                    loading: loading,
                }]}
            />
            <TicketDetailsModal
                open={openDetailsModal}
                handleClose={() => setOpenDetailsModal(false)}
                ticket={selectedTicket}
                loading={false}
            />
        </div>
    );
};

export default TicketSummary;